import React from "react";

export const CycleIcon = ({ size = 14, level = 0, fill = "#29394D" }) => (
<svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2847 8.80493H4.28273C3.88769 8.80493 3.56744 9.12517 3.56744 9.52021C3.56744 9.91525 3.88769 10.2355 4.28273 10.2355H11.2847C11.6797 10.2355 12 9.91525 12 9.52021C12 9.12517 11.6797 8.80493 11.2847 8.80493Z"
        fill="#29394D"
      />
      <path
        d="M9.33908 5.09473H2.33711C1.94207 5.09473 1.62183 5.41497 1.62183 5.81001C1.62183 6.20505 1.94207 6.52529 2.33711 6.52529H9.33908C9.73411 6.52529 10.0544 6.20505 10.0544 5.81001C10.0544 5.41497 9.73411 5.09473 9.33908 5.09473Z"
        fill="#29394D"
      />
      <path
        d="M7.71725 1.38452H0.715282C0.320243 1.38452 0 1.70476 0 2.0998C0 2.49484 0.320243 2.81508 0.715282 2.81508H7.71725C8.11229 2.81508 8.43253 2.49484 8.43253 2.0998C8.43253 1.70476 8.11229 1.38452 7.71725 1.38452Z"
        fill="#29394D"
      />
    </svg>
);
